export default {
    props: {
        xsDisplay: {
            type: Boolean,
            default: true,
        },
        smDisplay: {
            type: Boolean,
            default: undefined,
        },

        mdDisplay: {
            type: Boolean,
            default: undefined,
        },

        lgDisplay: {
            type: Boolean,
            default: undefined,
        },
        xlDisplay: {
            type: Boolean,
            default: undefined,
        },
        isBlock: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        getDisplayClass(prop, obj, classNamePrefix) {
            if (prop === undefined) {
                return
            }

            if (prop) {
                obj[classNamePrefix + (this.isBlock ? '-block' : '-inline')] = true
            } else {
                obj[classNamePrefix + '-none'] = true
            }
        },
    },
    computed: {
        displayClasses() {
            let res = {}

            this.getDisplayClass(this.xsDisplay, res, 'd')
            this.getDisplayClass(this.smDisplay, res, 'd-sm')
            this.getDisplayClass(this.mdDisplay, res, 'd-md')
            this.getDisplayClass(this.lgDisplay, res, 'd-lg')
            this.getDisplayClass(this.xlDisplay, res, 'd-xl')

            return res
        },
    },
}